"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AvailableSuggestionModels;
(function (AvailableSuggestionModels) {
    AvailableSuggestionModels["NODE"] = "node";
    AvailableSuggestionModels["RESOURCE"] = "resource";
})(AvailableSuggestionModels || (AvailableSuggestionModels = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTm9kZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9wdWJsaWMvaW50ZXJmYWNlcy9Ob2RlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBK0dBLElBQUsseUJBR0o7QUFIRCxXQUFLLHlCQUF5QjtJQUM1QiwwQ0FBYSxDQUFBO0lBQ2Isa0RBQXFCLENBQUE7QUFDdkIsQ0FBQyxFQUhJLHlCQUF5QixLQUF6Qix5QkFBeUIsUUFHN0IifQ==